import { Component, Input } from '@angular/core';
import { ItemRevisionDataset } from 'src/app/models/domain';

@Component({
  selector: 'em-related-specification-structure',
  templateUrl: './related-specification-structure.component.html',
  standalone: false,
})
export class RelatedSpecificationStructureComponent {
  @Input() public relatedSpecification: ItemRevisionDataset[] = [];
  @Input() public loading = false;
  @Input() public error = '';
}
